/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

import { TRIP_STATUS_CODES } from '@/constants';

// LYFT AND UBER
export const GET_LYFT_TRIP_ESTIMATION = 'app/App/GET_LYFT_TRIP_ESTIMATION';
export const GET_UBER_TRIP_ESTIMATION = 'app/App/GET_UBER_TRIP_ESTIMATION';
export const ON_FETCH_ESTIMATE_SUCCESS = 'app/App/ON_FETCH_ESTIMATE_SUCCESS';
export const ON_FETCH_ESTIMATE_ERROR = 'app/App/ON_FETCH_ESTIMATE_ERROR';
export const ON_CLEAR_ESTIMATES = 'app/App/ON_CLEAR_ESTIMATES';

export const ON_LOGOUT = 'app/App/ON_LOGOUT';
export const ON_LOGOUT_SUCCESS = 'app/App/ON_LOGOUT_SUCCESS';
export const ON_RESET_LOADING_STATE = 'app/App/ON_RESET_LOADING_STATE';
export const ON_ADD_ERROR = 'app/App/ON_ADD_MISC_ERROR';

export const ON_ADD_SUCCESS_MSG = 'app/App/ON_ADD_SUCCESS_MSG';
export const ON_ADD_ALERT_MSG = 'app/App/ON_ADD_ALERT_MSG';
export const ON_REMOVE_ONE_MESSAGE = 'app/App/ON_REMOVE_ONE_MESSAGE';
export const ON_REMOVE_OLDEST_MESSAGE = 'app/App/ON_REMOVE_OLDEST_MESSAGE';

export const ON_ADD_ACTION_ALERT = 'app/App/ON_ADD_ACTION_ALERT';
export const ON_REMOVE_ACTION_ALERT = 'app/App/ON_REMOVE_ACTION_ALERT';
export const ON_CLEAR_ALL_ACTION_ALERT = 'app/App/ON_CLEAR_ALL_ACTION_ALERT';

export const ON_ADD_APP_NOTIFICATION = 'app/App/ON_ADD_APP_NOTIFICATION';
export const ON_REMOVE_APP_NOTIFICATION = 'app/App/ON_REMOVE_APP_NOTIFICATION';

export const CREATE_ACCESS_TOKEN = 'app/App/CREATE_ACCESS_TOKEN';
export const CREATE_ACCESS_TOKEN_SUCCESS =
  'app/App/CREATE_ACCESS_TOKEN_SUCCESS';
export const CREATE_ACCESS_TOKEN_ERROR = 'app/App/CREATE_ACCESS_TOKEN_ERROR';

export const SEARCH_MEMBERS = 'app/App/SEARCH_MEMBERS';
export const SEARCH_MEMBERS_SUCCESS = 'app/App/SEARCH_MEMBERS_SUCCESS';
export const SEARCH_MEMBERS_ERROR = 'app/App/SEARCH_MEMBERS_ERROR';

export const ATTEMPT_UPDATE_MEMBER = 'app/App/ATTEMPT_UPDATE_MEMBER';

export const ON_LOAD_USER = 'app/App/ON_LOAD_USER';
export const ON_LOAD_USER_SUCCESS = 'app/App/ON_LOAD_USER_SUCCESS';
export const ON_LOAD_USER_ERROR = 'app/App/ON_LOAD_USER_ERROR';

export const ON_LOAD_ROLES = 'app/App/ON_LOAD_ROLES';
export const ON_LOAD_ROLES_SUCCESS = 'app/App/ON_LOAD_ROLES_SUCCESS';

export const ON_LD_CONTEXT_IDENTIFIED = 'app/App/ON_LD_CONTEXT_IDENTIFIED';

export const ON_LOAD_ORGANIZATIONS = 'app/App/ON_LOAD_ORGANIZATIONS';
export const ON_LOAD_ORGANIZATIONS_SUCCESS =
  'app/App/ON_LOAD_ORGANIZATIONS_SUCCESS';
export const ON_LOAD_ORGANIZATIONS_ERROR =
  'app/App/ON_LOAD_ORGANIZATIONS_ERROR';
export const ON_SET_ACTIVE_ORGANIZATION = 'app/App/ON_SET_ACTIVE_ORGANIZATION';

export const ATTEMPT_GET_MEMBER_PREFERENCES =
  'app/App/ATTEMPT_GET_MEMBER_PREFERENCES';
export const GET_MEMBER_PREFERENCES_SUCCESS =
  'app/App/GET_MEMBER_PREFERENCES_SUCCESS';
export const GET_MEMBER_PREFERENCES_ERROR =
  'app/App/GET_MEMBER_PREFERENCES_ERROR';

export const ATTEMPT_UPDATE_MEMBER_PREFERENCES =
  'app/App/ATTEMPT_UPDATE_MEMBER_PREFERENCES';

// Sidebar Related Constants
export const ON_CHANGE_TAB = 'app/App/ON_CHANGE_TAB';
export const ON_CHANGE_MENU = 'app/App/ON_CHANGE_MENU';
export const ON_SET_EXPANDED = 'app/App/ON_SET_EXPANDED';
export const ON_CHANGE_THEME = 'app/App/ON_CHANGE_THEME';
export const ON_CHANGE_THEME_SUCCESS = 'app/App/ON_CHANGE_THEME_SUCCESS';
export const ON_CHANGE_THEME_ERROR = 'app/App/ON_CHANGE_THEME_ERROR';

export const ON_FETCH_LOCATIONS = 'app/App/ON_FETCH_LOCATIONS';
export const ON_FETCH_LOCATIONS_SUCCESS = 'app/App/ON_FETCH_LOCATIONS_SUCCESS';
export const ON_FETCH_LOCATIONS_FAILED = 'app/App/ON_FETCH_LOCATIONS_FAILED';
export const CLEAR_FETCH_LOCATION_LOADING_STATE =
  'app/App/CLEAR_FETCH_LOCATION_LOADING_STATE';

export const ON_SELECT_LOCATION = 'app/App/ON_SELECT_LOCATION';
export const ON_SELECT_LOCATION_SUCCESS = 'app/App/ON_SELECT_LOCATION_SUCCESS';
export const ON_CLEAR_LOCATIONS = 'app/App/ON_CLEAR_LOCATIONS';

export const ON_SET_INACTIVITY_MODAL_VISIBILITY =
  'app/App/ON_SET_INACTIVITY_MODAL_VISIBILITY';

export const ON_SET_LYFT_TOKEN = 'app/App/ON_SET_LYFT_TOKEN';
export const ON_SET_UBER_TOKEN = 'app/App/ON_SET_UBER_TOKEN';
export const ON_SET_KINETIK_PROXY_TOKEN = 'app/App/ON_SET_KINETIK_PROXY_TOKEN';

export const ON_MARK_ALL_AS_READ_SUCCESS =
  'app/App/ON_MARK_ALL_AS_READ_SUCCESS';

export const GET_UNREAD_NOTIFICATIONS = 'app/App/GET_UNREAD_NOTIFICATIONS';
export const GET_UNREAD_NOTIFICATIONS_SUCCESS =
  'app/App/GET_UNREAD_NOTIFICATIONS_SUCCESS';
export const GET_UNREAD_NOTIFICATIONS_ERROR =
  'app/App/GET_UNREAD_NOTIFICATIONS_ERROR';

export const ON_GET_LEVELS_OF_SERVICE = 'app/App/ON_GET_LEVELS_OF_SERVICE';
export const ON_GET_LEVELS_OF_SERVICE_SUCCESS =
  'app/App/ON_GET_LEVELS_OF_SERVICE_SUCCESS';
export const ON_GET_LEVELS_OF_SERVICE_ERROR =
  'app/App/ON_GET_LEVELS_OF_SERVICE_ERROR';
export const UPDATE_LEVELS_OF_SERVICE = 'app/App/UPDATE_LEVELS_OF_SERVICE';

export const ON_GET_LOCATION_MODIFIERS = 'app/App/ON_GET_LOCATION_MODIFIERS';
export const ON_GET_LOCATION_MODIFIERS_SUCCESS =
  'app/App/ON_GET_LOCATION_MODIFIERS_SUCCESS';

export const ON_FETCH_ASSIGNEES = 'app/App/ON_FETCH_ASSIGNEES';
export const ON_FETCH_ASSIGNEES_SUCCESS = 'app/App/ON_FETCH_ASSIGNEES_SUCCESS';
export const ON_FETCH_ASSIGNEES_FAILED = 'app/App/ON_FETCH_ASSIGNEES_FAILED';

export const ON_FETCH_TNC_CONTRACTS_SUCCESS =
  'app/App/ON_FETCH_TNC_CONTRACTS_SUCCESS';
export const ON_FETCH_APPOINTMENT_REASONS =
  'app/App/ON_FETCH_APPOINTMENT_REASONS';
export const ON_FETCH_APPOINTMENT_REASONS_SUCCESS =
  'app/App/ON_FETCH_APPOINTMENT_REASONS_SUCCESS';
export const ON_FETCH_APPOINTMENT_REASONS_ERROR =
  'app/App/ON_FETCH_APPOINTMENT_REASONS_ERROR';

export const ON_FETCH_TNC_AGREEMENTS_SUCCESS =
  'app/App/ON_FETCH_TNC_AGREEMENTS_SUCCESS';

export const GET_UNREAD_MESSAGE_COUNT = 'app/App/GET_UNREAD_MESSAGE_COUNT';
export const SET_UNREAD_MESSAGE_COUNT = 'app/App/SET_UNREAD_MESSAGE_COUNT';
export const ON_TRIP_CHANGE_WATCH_EVENT =
  'app/App/ON_TRIP_CHANGE_WATCHER_EVENT';

export const headerSortConversion = {
  name: 'firstName',
};

export const allowedIndustrySegmentCodes = ['MCO', 'TB', 'HP'];

export const SELECT_FILTER_DATA = 'app/App/SELECT_FILTER_DATA';
export const REMOVE_SELECTED_FILTER_DATA =
  'app/App/REMOVE_SELECTED_FILTER_DATA';
export const UPDATE_GLOBAL_SEARCHBAR_KEY =
  'app/App/UPDATE_GLOBAL_SEARCHBAR_KEY';
export const REMOVE_GLOBAL_SEARCH_VALUE = 'app/App/REMOVE_GLOBAL_SEARCH_VALUE';

export const SET_GLOBAL_SEARCH_INPUT_VALUE =
  'app/App/SET_GLOBAL_SEARCH_INPUT_VALUE';
export const OPEN_GLOBAL_SEARCH_BOX = 'app/App/OPEN_GLOBAL_SEARCH_BOX';

export const GET_TRIP_PREFERENCES = 'app/App/GET_TRIP_PREFERENCES';
export const GET_TRIP_PREFERENCES_SUCCESS =
  'app/App/GET_TRIP_PREFERENCES_SUCCESS';
export const GET_TRIP_PREFERENCES_ERROR = 'app/App/GET_TRIP_PREFERENCES_ERROR';

export const ATTEMPT_UPDATE_TRIP_PREFERENCES =
  'app/App/ATTEMPT_UPDATE_TRIP_PREFERENCES';
export const UPDATE_TRIP_PREFERENCES_SUCCESS =
  'app/App/UPDATE_TRIP_PREFERENCES_SUCCESS';
export const UPDATE_TRIP_PREFERENCES_FAILED =
  'app/App/UPDATE_TRIP_PREFERENCES_FAILED';

export const GET_TRIP_CANCELLATION_REASONS =
  'payer-scheduler/App/GET_TRIP_CANCELLATION_REASONS';

export const GET_TRIP_CANCELLATION_REASONS_SUCCESS =
  'payer-scheduler/App/GET_TRIP_CANCELLATION_REASONS_SUCCESS';

export const GET_TRIP_CANCELLATION_REASONS_ERROR =
  'payer-scheduler/App/GET_TRIP_CANCELLATION_REASONS_ERROR';

export const GET_TRIP_DENIAL_REASONS = 'app/App/GET_TRIP_DENIAL_REASONS';

export const GET_TRIP_DENIAL_REASONS_SUCCESS =
  'app/App/GET_TRIP_DENIAL_REASONS_SUCCESS';

export const GET_TRIP_DENIAL_REASONS_ERROR =
  'app/App/GET_TRIP_DENIAL_REASONS_ERROR';

export const GET_TRIP_ASSIGNMENT_PREFERENCE =
  'app/App/GET_TRIP_ASSIGNMENT_PREFERENCE';

export const GET_TRIP_ASSIGNMENT_PREFERENCE_SUCCESS =
  'app/App/GET_TRIP_ASSIGNMENT_PREFERENCE_SUCCESS';

export const GET_TRIP_ASSIGNMENT_PREFERENCE_ERROR =
  'app/App/GET_TRIP_ASSIGNMENT_PREFERENCE_ERROR';

export const GET_VEHICLE_CATEGORIES = 'app/App/GET_VEHICLE_CATEGORIES';
export const GET_VEHICLE_CATEGORIES_SUCCESS =
  'app/App/GET_VEHICLE_CATEGORIES_SUCCESS';
export const GET_VEHICLE_CATEGORIES_ERROR =
  'app/App/GET_VEHICLE_CATEGORIES_ERROR';
export const GET_PROCREDEX_CONNECTION_STATUS =
  'app/App/GET_PROCREDEX_CONNECTION_STATUS';
export const GET_PROCREDEX_CONNECTION_STATUS_SUCCESS =
  'app/App/GET_PROCREDEX_CONNECTION_STATUS_SUCCESS';
export const GET_PROCREDEX_CONNECTION_STATUS_ERROR =
  'app/App/GET_PROCREDEX_CONNECTION_STATUS_ERROR';
export const SET_SIDEBAR_MENU_COUNT = 'app/App/SET_SIDEBAR_MENU_COUNT';

export const GET_TRIP_ESCALATION_REASON = 'app/App/GET_TRIP_ESCALATION_REASON';

export const GET_TRIP_ESCALATION_REASON_SUCCESS =
  'app/App/GET_TRIP_ESCALATION_REASON_SUCCESS';

export const GET_TRIP_ESCALATION_REASON_ERROR =
  'app/App/GET_TRIP_ESCALATION_REASON_ERROR';

export const GET_TRIP_APPROVAL_REASON = 'app/App/GET_TRIP_APPROVAL_REASON';

export const GET_TRIP_APPROVAL_REASON_SUCCESS =
  'app/App/GET_TRIP_APPROVAL_REASON_SUCCESS';

export const GET_TRIP_APPROVAL_REASON_ERROR =
  'app/App/GET_TRIP_APPROVAL_REASON_ERROR';

export const CREATE_APPROVED_LOCATION = `payer-scheduler/App/CREATE_APPROVED_LOCATION`;
export const CREATE_APPROVED_LOCATION_SUCCESS = `payer-scheduler/App/CREATE_APPROVED_LOCATION_SUCCESS`;
export const CREATE_APPROVED_LOCATION_ERROR = `payer-scheduler/App/CREATE_APPROVED_LOCATION_ERROR`;

export const FETCH_LYFT_DRIVER_AVAILABILITY = `payer-scheduler/App/FETCH_LYFT_DRIVER_AVAILABILITY`;
export const FETCH_LYFT_DRIVER_AVAILABILITY_SUCCESS = `payer-scheduler/App/FETCH_LYFT_DRIVER_AVAILABILITY_SUCCESS`;
export const FETCH_LYFT_DRIVER_AVAILABILITY_ERROR = `payer-scheduler/App/FETCH_LYFT_DRIVER_AVAILABILITY_ERROR`;

export const GET_TRIP_GROUPINGS = 'app/App/GET_TRIP_GROUPINGS';
export const GET_TRIP_GROUPINGS_SUCCESS = 'app/App/GET_TRIP_GROUPINGS_SUCCESS';
export const GET_TRIP_GROUPINGS_ERROR = 'app/App/GET_TRIP_GROUPINGS_ERROR';

export const GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS =
  'app/App/GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS';
export const GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS_SUCCESS =
  'app/App/GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS_SUCCESS';
export const GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS_ERROR =
  'app/App/GET_MEMBER_ENROLLMENT_COVERAGE_TRIP_COUNTS_ERROR';

export const GET_TRIPS_COUNT = 'app/App/GET_TRIPS_COUNT';
export const GET_NEEDS_ACTION_TRIPS_COUNT =
  'app/App/GET_NEEDS_ACTION_TRIPS_COUNT';

export const GLOBAL_SEARCH = `app/App/GLOBAL_SEARCH`;
export const GLOBAL_SEARCH_SUCCESS = `app/App/GLOBAL_SEARCH_SUCCESS`;
export const GLOBAL_SEARCH_ERROR = `app/App/GLOBAL_SEARCH_ERROR`;
export const RESET_GLOBAL_SEARCH_RESULTS = `app/App/RESET_GLOBAL_SEARCH_RESULTS`;

export const ON_FETCH_CONTRACTS = 'app/App/ON_FETCH_CONTRACTS';
export const ON_FETCH_CONTRACTS_SUCCESS = 'app/App/ON_FETCH_CONTRACTS_SUCCESS';
export const ON_FETCH_CONTRACTS_ERROR = 'app/App/ON_FETCH_CONTRACTS_ERROR';

export const SORT_PARAMS = {
  DISPLAY_TEXT: 'displayText',
  ASSIGNEE_NAME: 'assignee.name',
};

export const countUpdateStatuses = [
  TRIP_STATUS_CODES.APPROVAL_PENDING,
  TRIP_STATUS_CODES.APPROVAL_DENIED,
  TRIP_STATUS_CODES.READY_TO_ASSIGN,
  TRIP_STATUS_CODES.ASSIGNMENT_PENDING,
  TRIP_STATUS_CODES.ASSIGNMENT_ACCEPTED,
];

export const UI_TYPES = {
  NEW_UI: 'new-ui',
  LIGHT_UI: 'light-ui',
};

export const DEFAULT_DAYS_FOR_TABLE_COOKIES_TO_EXPIRE = 15;

export const GLOBAL_SEARCH_RESULTS_LIMIT_PER_RESOURCE = 3;

export const ADD_TOAST_NOTIFICATION = 'app/App/ADD_TOAST_NOTIFICATION';
export const REMOVE_TOAST_NOTIFICATION = 'app/App/REMOVE_TOAST_NOTIFICATION';
export const UPDATE_TOAST_NOTIFICATION = 'app/App/UPDATE_TOAST_NOTIFICATION';
export const CLEAR_ALL_TOAST_NOTIFICATIONS =
  'app/App/CLEAR_ALL_TOAST_NOTIFICATIONS';
